module.exports = __webpack_public_path__ + "static/img/printed_shower.30958c3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/LandingPage/img/printed_shower.jpg
// module id = 504
// module chunks = 0